import Vue from 'vue'
import Router from 'vue-router'
const isDevelopment = process.env.NODE_ENV === 'development'
const modeType = isDevelopment?'hash':'history'
Vue.use(Router)

export default new Router({
  mode: modeType,
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'treatPage',
      meta: {
        title: '理疗工作台',
        level: '1',
        keepAlive: true // 需要缓存
      },
      component: resolve => require(['@/view/treatPage'], resolve)
    },
    {
      path: '/treatDetail',
      name: 'treatDetail',
      meta: {
        title: '理疗详情',
        level: '1',
        keepAlive: false // 需要缓存
      },
      component: resolve => require(['@/view/treatDetail'], resolve)
    },
    {
      path: '/treatExec',
      name: 'treatExec',
      meta: {
        title: '分诊/完成',
        level: '1',
        keepAlive: false // 不需要缓存
      },
      component: resolve => require(['@/view/treatExec'], resolve)
    },
    {
      path: '/historyPage',
      name: 'historyPage',
      meta: {
        title: '理疗历史',
        level: '1',
        keepAlive: false // 不需要缓存
      },
      component: resolve => require(['@/view/historyPage'], resolve)
    },
    {
      path: '/medicalPage',
      name: 'medicalPage',
      meta: {
        title: '患者病历',
        level: '1',
        keepAlive: false // 不需要缓存
      },
      component: resolve => require(['@/view/medicalPage'], resolve)
    },
    {
      path: '/medicalDetail',
      name: 'medicalDetail',
      meta: {
        title: '病历详情',
        level: '1',
        keepAlive: false // 不需要缓存
      },
      component: resolve => require(['@/view/medicalDetail'], resolve)
    },
    {
      path: '/my',
      name: 'my',
      meta: {
        title: '我的',
        level: '1',
        keepAlive: false // 不需要缓存
      },
      component: resolve => require(['@/view/my'], resolve)
    },
    {
      path: '/seePage',
      name: 'seePage',
      meta: {
        title: '医生工作台',
        level: '1',
        keepAlive: true // 需要缓存
      },
      component: resolve => require(['@/view/seePage'], resolve)
    },
    {
      path: '/changeClinic',
      name: 'changeClinic',
      meta: {
        title: '切换诊所',
        level: '1',
        keepAlive: false // 不需要缓存
      },
      component: resolve => require(['@/view/changeClinic'], resolve)
    },
    {
      path: '/bindLogin',
      name: 'bindLogin',
      meta: {
        title: '绑定账号',
        level: '1',
        keepAlive: false // 不需要缓存
      },
      component: resolve => require(['@/view/bindLogin'], resolve)
    },
    {
      path: '/takePicture',
      name: 'takePicture',
      meta: {
        title: '拍照上传',
        level: '1',
        keepAlive: false // 不需要缓存
      },
      component: resolve => require(['@/view/takePicture'], resolve)
    },
    {
      path: '/checkPage',
      name: 'checkPage',
      meta: {
        title: '检查历史',
        level: '1',
        keepAlive: false // 不需要缓存
      },
      component: resolve => require(['@/view/checkPage'], resolve)
    },
    {
      path: '/matchAcupoint',
      name: 'matchAcupoint',
      meta: {
        title: '配穴操作',
        level: '1',
        keepAlive: false // 不需要缓存
      },
      component: resolve => require(['@/view/matchAcupoint'], resolve)
    },
    {
      path: '/habitusDetail',
      name: 'habitusDetail',
      meta: {
        title: '五行体质报告',
        level: '1',
        keepAlive: false // 需要缓存
      },
      component: resolve => require(['@/view/habitusDetail'], resolve)
    },
    {
      path: '/infraredDetail',
      name: 'infraredDetail',
      meta: {
        title: '红外报告',
        level: '1',
        keepAlive: false // 需要缓存
      },
      component: resolve => require(['@/view/infraredDetail'], resolve)
    },
  ]
})
